module.exports = __webpack_public_path__ + "static/img/工地-2.df5c8549.png";